<div class="confirmation-popup">
  <!-- <mat-dialog-content class="p-0 m-0 confirmation-popup__dialog-content"> -->
  <div>
    <div class="confirmation-popup__apiresponsediv activity-description-bold">
      @if (!isScrolable) {
        <p class="confirmation-popup__message seat-alert-messages" id="confirmationMsg"
        [innerHTML]="confirmationMessage"></p>
      }
      @if (isScrolable) {
        <div class="confirmation-popup__message confirmation-popup_scrollable seat-alert-messages"
        id="confirmationMsg" [innerHTML]="confirmationMessage"></div>
      }
    </div>
  </div>


</div>